import type { ReactNode } from 'react';
import classNames from 'classnames';

import { useWindowSize } from '@/utils/WindowSizeProvider';
import useAppSelector from '@/hooks/useAppSelector';

export const Layout = ({ children }: { children: ReactNode }) => {
    const mapOpen = useAppSelector((state) => state.map.open);
    const { isMobile } = useWindowSize();

    if (typeof window !== 'undefined') {
        const advertising = document.querySelector('[data-testid="advertising"]');

        if (mapOpen) {
            advertising?.classList.add('u-display-none');
        } else {
            advertising?.classList.remove('u-display-none');
        }
    }

    return (
        <>
            <div id="content">
                <main
                    className={classNames('no-focus-ring', {
                        'probably-not-touch': isMobile,
                        pageholder: !mapOpen,
                        'map-pageholder': mapOpen,
                    })}>
                    {children}
                </main>
            </div>
        </>
    );
};
